/* istanbul ignore file */
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import React from 'react';
import { Collapsible, HtmlField } from 'framework/ui/field';
import TimelineRecordHeader from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordHeader';
import FeedbackFooter from 'domain/people/employee/Timeline/feedback/shared/layout/FeedbackFooter';
import { FEEDBACKS_ABOUT_ME } from 'domain/people/employee/feedbacks/EmployeeFeedbacksService';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { useShowContext } from 'framework/show';

const FeedbackNoteTimelineRecordLayout = ({ ...props }) => {
  const { data: entity } = useShowContext();
  const feedbackText = entity.getValueBySource('feedbackText');

  return (
    <BaseTimelineRecordLayout
      actionName=""
      permissionToCheck={FEEDBACKS_ABOUT_ME}
      timelineType={TimelineType.FEEDBACK}
      buttons={[]}
      fields={
        feedbackText ? (
          <Collapsible>
            <HtmlField source="feedbackText" label="" />
          </Collapsible>
        ) : null
      }
      timelineHeader={(rest: any) => <TimelineRecordHeader {...rest} />}
      timelineActions={() => null}
      timelineFooter={(rest: any) => <FeedbackFooter {...rest} isFeedbackAboutMeTab />}
      {...props}
    />
  );
};

export default FeedbackNoteTimelineRecordLayout;
